import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42b06e78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between py-3 border-b" }
const _hoisted_2 = { class: "text-sm font-bold" }


export default /*#__PURE__*/_defineComponent({
  props: {
  text: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1),
    _createElementVNode("div", null, _toDisplayString(__props.value), 1)
  ]))
}
}

})